export class JobPlatform {
  Id: number;
  ProfileSourceId: number;
  Name: string;
  CreatedDate: Date;
  CreatedBy: string;
  ModifiedBy: string;
  ModifiedDate: Date;
}
